import { render, staticRenderFns } from "./PlatformAlertBanner.vue?vue&type=template&id=08e89aca&scoped=true&"
import script from "./PlatformAlertBanner.vue?vue&type=script&lang=js&"
export * from "./PlatformAlertBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAlertBanner.vue?vue&type=style&index=0&id=08e89aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e89aca",
  null
  
)

export default component.exports